import {
  GridItem,
  SelectInputField,
  TextInputField,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Field, useField } from "formik";
import { useTranslation } from "react-i18next";
import { Item } from "react-stately";

import { PurposeInfoModal } from "./PurposeInfoModal";
import { purposeTypes } from "./constants";

export function PurposeInputField({
  field,
}: {
  field: components["schemas"]["PurposeCheckField"];
}) {
  const { t } = useTranslation();
  const [, meta, helpers] = useField(field.name);

  return (
    <>
      <GridItem>
        <Field
          isRequired
          as={SelectInputField}
          label={t("Purpose of check")}
          placeholder={t("Please select")}
          name={`${field.name}.purpose_of_check`}
          info={<PurposeInfoModal />}
          onChange={(value: string) => {
            if (value !== meta.value.purpose_of_check) {
              // clear all fields when purpose changes
              helpers.setValue({
                purpose_of_check: value,
                position_title: "",
                place_of_work: "",
                license_type: "",
                issuing_authority: "",
                reason_for_check: "",
              });
            }
          }}
          isDisabled={!field.purpose_of_check_editable}
          testID="purpose-of-check-purpose-of-check-select"
        >
          {Object.entries(purposeTypes).map(([key, value]) => (
            <Item key={key}>{value}</Item>
          ))}
        </Field>
      </GridItem>

      {meta.value.purpose_of_check === "EMPLOYMENT" && (
        <>
          <GridItem>
            <Field
              isRequired
              as={TextInputField}
              label={t("Role or position title")}
              name={`${field.name}.position_title`}
              isDisabled={!field.position_title_editable}
              testID="purpose-of-check-role-or-position-input"
            />
          </GridItem>

          <GridItem>
            <Field
              isRequired
              as={TextInputField}
              label={t("Organization, type or place of work")}
              name={`${field.name}.place_of_work`}
              isDisabled={!field.place_of_work_editable}
              testID="purpose-of-check-type-or-place-of-work-input"
            />
          </GridItem>
        </>
      )}

      {meta.value.purpose_of_check === "LICENSE" && (
        <>
          <GridItem>
            <Field
              isRequired
              as={TextInputField}
              label={t("License type")}
              name={`${field.name}.license_type`}
              isDisabled={!field.license_type_editable}
              testID="purpose-of-check-license-type-input"
            />
          </GridItem>

          <GridItem>
            <Field
              isRequired
              as={TextInputField}
              label={t("Issuing authority")}
              name={`${field.name}.issuing_authority`}
              isDisabled={!field.issuing_authority_editable}
              testID="purpose-of-check-issuing-authority-input"
            />
          </GridItem>
        </>
      )}

      {meta.value.purpose_of_check === "OTHER" && (
        <>
          <GridItem>
            <Field
              isRequired
              as={TextInputField}
              label={t("Reason for check")}
              name={`${field.name}.reason_for_check`}
              isDisabled={!field.reason_for_check_editable}
              testID="purpose-of-check-reason-for-check-input"
            />
          </GridItem>

          <GridItem>
            <Field
              isRequired
              as={TextInputField}
              label={t("Requesting organization")}
              name={`${field.name}.place_of_work`}
              isDisabled={!field.place_of_work_editable}
              testID="purpose-of-check-requesting-organization-input"
            />
          </GridItem>
        </>
      )}
    </>
  );
}
